module.exports = __webpack_public_path__ + "static/media/400x400-AYCM-DokiApp-banner-eng.37936891.png";